import { QuestionCircleOutlined, GithubOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang } from '@umijs/max';
import { useIntl } from '@umijs/max';
import React from 'react';
import { getLocale } from 'umi';

export type SiderTheme = 'light' | 'dark';

export const SelectLang = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
        marginRight: 10,
      }}
    />
  );
};

export const Question = () => {
  return (
    <div
      style={{
        display: 'flex',
        height: 26,
      }}
      onClick={() => {
        window.open('https://pro.ant.design/docs/getting-started');
      }}
    >
      <QuestionCircleOutlined />
    </div>
  );
};

export const GithubBtn = () => {
  return (
    <div
      style={{
        display: 'flex',
        height: 26,
        marginRight: 10,
      }}
      onClick={() => {
        window.open('https://github.com/ecovacs-ai/ecovacs-mcp');
      }}
    >
      <GithubOutlined />
    </div>
  );
};

export const GetAKBtn = () => {
  const intl = useIntl();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center', // 垂直居中
        justifyContent: 'center', // 水平居中
        height: 40, // 设置按钮高度
        width: 120, // 设置按钮宽度
        backgroundColor: '#1890ff', // 蓝色背景
        color: '#fff', // 白色文字
        borderRadius: '12px', // 圆角
        cursor: 'pointer', // 鼠标悬停时显示手型
        textAlign: 'center', // 文字居中
      }}
      onClick={() => {
        const host = location.host;
        window.open(`http://${host}/auth/login?lang=${getLocale() === 'zh-CN' ? 'zh-cn' : 'en'}`);
      }}
    >
      {intl.formatMessage({ id: 'menu.getAK' })}
    </div>
  );
};
